import Logger from '../util/Logger';
import _ from 'lodash';

export default {

  /**
   * Number of unique users that have viewed the event
   */
  getReachCount (stats) {
    if (!stats) {
      Logger.assert('Must pass a stats object');
    } else {
      // Let the server return 0 as a valid value.
      // The view should explicitly check against undefined|null instead of just a falsey assumption.
      return _.get(stats, 'metrics.viewed_user');
    }
  },

  /**
   * Number of unique users that have viewed the event
   */
  getChoicesCount (stats) {
    if (!stats) {
      Logger.assert('Must pass a stats object');
    } else {
      return _.get(stats, 'metrics.choices') || 0;
    }
  },

  getViewsCount (stats) {
    if (!stats) {
      Logger.assert('Must pass a stats object');
    } else {
      return _.get(stats, 'metrics.views') || 0;
    }
  },

  getViewedUserCount (stats) {
    if (!stats) {
      Logger.assert('Must pass a stats object');
    } else {
      return _.get(stats, 'metrics.viewed_user') || 0;
    }
  },

  getIdeaLikeCount (stats) {
    if (!stats) {
      Logger.assert('Must pass a stats object');
    } else {
      return _.get(stats, 'metrics.idea_likes') || 0;
    }
  },

  getCommentLikeCount (stats) {
    if (!stats) {
      Logger.assert('Must pass a stats object');
    } else {
      return _.get(stats, 'metrics.comment_likes') || 0;
    }
  },

  getTotalContributionsCount (stats) {
    if (!stats) {
      Logger.assert('Must pass a stats object');
    } else {
      return _.get(stats, 'metrics.total_activities') || 0;
    }
  },

  getUsersWhoWereInvitedCount (stats) {
    if (!stats) {
      Logger.assert('Must pass a stats object');
    } else {
      return _.get(stats, 'metrics.invited') || 0;
    }
  },

  getUsersWhoContributedCount (stats) {
    if (!stats) {
      Logger.assert('Must pass a stats object');
    } else {
      return _.get(stats, 'metrics.contributed') || 0;
    }
  },

  getResponseCount (stats) {
    if (!stats) {
      Logger.assert('Must pass a stats object');
    } else {
      return _.get(stats, 'metrics.ideas') || 0;
    }
  },

  getResponderCount (stats) {
    if (!stats) {
      Logger.assert('Must pass a stats object');
    } else {
      return _.get(stats, 'metrics.idea_creator') || 0;
    }
  },

  getResponseVoteCount (stats) {
    if (!stats) {
      Logger.assert('Must pass a stats object');
    } else {
      return _.get(stats, 'metrics.votes') || 0;
    }
  },

  getResponseVoterCount (stats) {
    if (!stats) {
      Logger.assert('Must pass a stats object');
    } else {
      return _.get(stats, 'metrics.vote_creator') || 0;
    }
  },

  getCommentCount (stats) {
    if (!stats) {
      Logger.assert('Must pass a stats object');
    } else {
      return _.get(stats, 'metrics.comments');
    }
  },

  getCommenterCount (stats) {
    if (!stats) {
      Logger.assert('Must pass a stats object');
    } else {
      return _.get(stats, 'metrics.comment_creator') || 0;
    }
  },

  getCommentVoteCount (stats) {
    if (!stats) {
      Logger.assert('Must pass a stats object');
    } else {
      return _.get(stats, 'metrics.comment_votes') || 0;
    }
  },

  getTotalVoterCount (stats) {
    if (!stats) {
      Logger.assert('Must pass a stats object');
    } else {
      return _.get(stats, 'metrics.total_vote_creator') || 0;
    }
  },

  getCommentVoterCount (stats) {
    if (!stats) {
      Logger.assert('Must pass a stats object');
    } else {
      return _.get(stats, 'metrics.comment_vote_creator') || 0;
    }
  },

  getAndroidActivityCount (stats) {
    if (!stats) {
      Logger.assert('Must pass a stats object');
    } else {
      return _.get(stats, 'metrics.android_activity') || 0;
    }
  },

  getDesktopActivityCount (stats) {
    if (!stats) {
      Logger.assert('Must pass a stats object');
    } else {
      return _.get(stats, 'metrics.desktop_activity') || 0;
    }
  },

  getIosActivityCount (stats) {
    if (!stats) {
      Logger.assert('Must pass a stats object');
    } else {
      return _.get(stats, 'metrics.ios_activity') || 0;
    }
  },

  getMobileWebActivityCount (stats) {
    if (!stats) {
      Logger.assert('Must pass a stats object');
    } else {
      return _.get(stats, 'metrics.mobile_web_activity') || 0;
    }
  },

  getTotalActivityCount (stats) {
    if (!stats) {
      Logger.assert('Must pass a stats object');
    } else {
      return _.get(stats, 'metrics.total_activities') || 0;
    }
  },

  getMinScoreDisplay (stats) {
    if (!stats) {
      Logger.assert('Must pass a stats object');
    } else {
      return _.get(stats, 'summary.min_score_display') || '';
    }
  },

  getMaxScoreDisplay (stats) {
    if (!stats) {
      Logger.assert('Must pass a stats object');
    } else {
      return _.get(stats, 'summary.max_score_display') || '';
    }
  },

  getSimpleScoreDisplay (stats) {
    if (!stats) {
      Logger.assert('Must pass a stats object');
    } else {
      return _.get(stats, 'summary.simple_score_display') || '';
    }
  },

  getMinScore (stats) {
    if (!stats) {
      Logger.assert('Must pass a stats object');
    } else {
      return _.get(stats, 'summary.min_score') || null;
    }
  },

  getMaxScore (stats) {
    if (!stats) {
      Logger.assert('Must pass a stats object');
    } else {
      return _.get(stats, 'summary.max_score') || null;
    }
  },

  getSimpleScore (stats) {
    if (!stats) {
      Logger.assert('Must pass a stats object');
    } else {
      return _.get(stats, 'summary.simple_score') || null;
    }
  },

  getPositiveSentimentCount (stats) {
    if (!stats) {
      Logger.assert('Must pass a stats object');
    } else {
      return _.get(stats, 'metrics.posts_sentiment_positive') || 0;
    }
  },

  getNegativeSentimentCount (stats) {
    if (!stats) {
      Logger.assert('Must pass a stats object');
    } else {
      return _.get(stats, 'metrics.posts_sentiment_negative') || 0;
    }
  },

  getNeutralSentimentCount (stats) {
    if (!stats) {
      Logger.assert('Must pass a stats object');
    } else {
      return _.get(stats, 'metrics.posts_sentiment_neutral') || 0;
    }
  },

  getDesktopUserCount (stats) {
    if (!stats) {
      Logger.assert('Must pass a stats object');
    } else {
      return _.get(stats, 'metrics.desktop_user') || 0;
    }
  },

  getAndroidUserCount (stats) {
    if (!stats) {
      Logger.assert('Must pass a stats object');
    } else {
      return _.get(stats, 'metrics.android_user') || 0;
    }
  },

  getIosUserCount (stats) {
    if (!stats) {
      Logger.assert('Must pass a stats object');
    } else {
      return _.get(stats, 'metrics.ios_user') || 0;
    }
  },

  getMobileWebUserCount (stats) {
    if (!stats) {
      Logger.assert('Must pass a stats object');
    } else {
      return _.get(stats, 'metrics.mobile_web_user') || 0;
    }
  }

};
